import styled, { css } from 'styled-components';

import { Button } from '@xsolla/ui-core';

export const Wrapper = styled.div``;

export const HTMLEditorViewModeButton = styled(Button)`
  flex-shrink: 1;
`;

const activeModeStyles = css`
  color: ${(props) => props.theme.colors.brand};
`;

export const HTMLModeLabel = styled.div<{ isViewMode: boolean }>`
  color: ${(props) => props.theme.colors.muted};
  ${(props) => !props.isViewMode && activeModeStyles}
`;

export const ViewModeLabel = styled.div<{ isViewMode: boolean }>`
  text-align: start;
  color: ${(props) => props.theme.colors.muted};
  ${(props) => props.isViewMode && activeModeStyles}
`;
